export default (urlParameters) => {
  return {}
}